import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Label,
  Button,
  Card,
  CardBody,
} from "reactstrap";

const ViewSupplierModal = ({ isOpen, toggle, supplier }) => {
  if (!supplier) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle} className="bg-light fw-bold">
        Supplier Details
      </ModalHeader>

      <ModalBody className="p-4">
        <Card className="shadow-sm border-0">
          <CardBody className="p-3">
            <Row className="gy-3">
              <Col md={6}>
                <div>
                  <strong>Name: </strong>
                  {supplier.name || "-"}
                </div>
              </Col>

              <Col md={6}>
                <div>
                  <strong>Email: </strong>
                  {supplier.email || "-"}
                </div>
              </Col>

              <Col md={6}>
                <div>
                  <strong>Mobile No: </strong>
                  {supplier.mobileNo || "-"}
                </div>
              </Col>

              <Col md={6}>
                <div>
                  <strong>Secondary Mobile No: </strong>
                  {supplier.mobileSecNo || "-"}
                </div>
              </Col>

              <Col md={6}>
                <div>
                  <strong>State: </strong>
                  {supplier.state || "-"}
                </div>
              </Col>

              <Col md={6}>
                <div>
                  <strong>Party Type: </strong>
                  {supplier.partyType || "-"}
                </div>
              </Col>

              <Col md={6}>
                <div>
                  <strong>Per KM Rate: </strong>
                  {supplier.km || "-"}
                </div>
              </Col>

              <Col md={6}>
                <div>
                  <strong>Per Trip Rate: </strong>
                  {supplier.perTripRate ? `₹ ${supplier.perTripRate}` : "-"}
                </div>
              </Col>

              <Col md={12}>
                <div>
                  <strong>Address: </strong>
                  {supplier.address || "-"}
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <div className="text-end mt-3">
          <Button color="secondary" className="btn-sm" onClick={toggle}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ViewSupplierModal;
